import { Align, Button, Container, Spacer, Text } from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';

import { openModal } from 'actions/modals';
import { ANON_CREATOR_SIGNUP_MODAL } from 'constants/modalTypes';

import PointToVideoIllo from 'img/point-to-video.png';

const AnonCreatorViewerInsightsModal = () => {
  const dispatch = useDispatch();

  const openAnonCreatorAuthModal = () => {
    dispatch(openModal(ANON_CREATOR_SIGNUP_MODAL));
  };

  return (
    <Container
      backgroundColor="background"
      borderSide="all"
      paddingX="large"
      paddingY="xlarge"
      position="absolute"
      radius="medium"
      right="0"
      shadow="large"
      top="calc(100% + var(--lns-space-small))"
      width="22.5rem"
    >
      <Align alignment="center">
        <img alt="" src={PointToVideoIllo} height="132" width="132" />
        <Spacer top="xlarge" />
        <Text size="large" fontWeight="bold">
          Learn more about your views
        </Text>
        <Spacer top="small" />
        <Text alignment="center">
          Get notified when this video has been watched.
        </Text>
        <Spacer top="large" />
        <Button variant="primary" onClick={openAnonCreatorAuthModal}>
          Sign up for Engagement Insights
        </Button>
      </Align>
    </Container>
  );
};

export default AnonCreatorViewerInsightsModal;
